const Request = require('./BaseRequest')
const EmsGraph = require('../graph/EmsGraph')

module.exports = class EmsRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new EmsGraph(this.apiDomain)
    }

    swrNewsletters(accountId)
    {
        let args = {account_id: accountId, type: "1"}
        let { type, query } = this.graph.mailingQuery([
            'id', 'month', 'year', 'image', 'title', 'link', 'description'
        ], args)
        
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    async newsletters(accountId)
    {
        let args = {account_id: accountId, type: "1"}
        let { type, query } = this.graph.mailingQuery([
            'id', 'month', 'year', 'image', 'title', 'link', 'description'
        ], args)
        let data = await this.graph.request(query, args, type)
        
        return data;
    }

    swrNewsletterDetails(id)
    {
        let args = {mailing_id: id, mailing_type: 1}
        let { type, query } = this.graph.mailingDetailsQuery([
            'id', 'month', 'year', 'title', 'descriptions', 'content'
        ], args)
        
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    async newsletterDetails(id)
    {
        let args = {mailing_id: id, mailing_type: 1}
        let { type, query } = this.graph.mailingDetailsQuery([
            'id', 'month', 'year', 'title', 'descriptions','content'
        ], args)
        let data = await this.graph.request(query, args, type)
        
        return data;
    }
    
}